import Modal from "../components/ModalWindow";
import React from "react";

interface Props {
  isModalOpen: boolean;
  closeRemainderModal: () => void;
  closeModal: () => void;
  firstNameFirstLetter: string;
  lastNameFirstLetter: string;
  fullName: string;
  vesselName: string | undefined;
  vesselCode: string | undefined;
  confirmTechFormRequest: () => Promise<void>;
}

export function ReminderModal({
  isModalOpen,
  closeRemainderModal,
  closeModal,
  firstNameFirstLetter,
  lastNameFirstLetter,
  fullName,
  vesselName,
  vesselCode,
  confirmTechFormRequest,
}: Props) {
  return (
    <Modal isOpen={isModalOpen} closeModal={closeRemainderModal}>
      <div>
        <div className="flex justify-between">
          <div className="text-custom-color text-lg font-bold">Confirm data request</div>
          <button className="rounded bg-white px-4 py-2" onClick={closeModal}>
            X
          </button>
        </div>
        <div className="pb-4">
          <label>You’re sending form to the vessel master. Please, confirm your submission.</label>
        </div>
        <div className="rounded-lg bg-success">
          <div className="grid grid-cols-2 gap-4 p-2">
            {/* ... Input fields and error messages */}
            <div className="mb-4">
              <div className="block text-xs font-medium text-lightGrey">Type of request</div>
              <div>Technical questionnaire</div>
            </div>
            <div className="mb-4">
              <div className="block text-xs font-medium text-lightGrey">Request by</div>

              <div>
                <span className="rounded-lg bg-white text-xs uppercase text-green">
                  {firstNameFirstLetter}
                  {lastNameFirstLetter}
                </span>{" "}
                {fullName}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-4 p-2">
            <div className="mb-4">
              <div className="block text-xs font-medium text-lightGrey">Vessel name</div>
              <div>{vesselName}</div>
            </div>
            <div className="mb-4">
              <div className="block text-xs font-medium text-lightGrey">Vessel code</div>
              <div>{vesselCode}</div>
            </div>
            <div className="mb-4">
              <div className="block text-xs font-medium text-lightGrey">Owners email</div>
              <input
                type="text"
                id="username"
                className="w-full rounded border p-2 focus:border-blue-500 focus:outline-none"
              />
            </div>
          </div>
        </div>
        <footer className="flex justify-end p-4">
          <div className="grid grid-cols-2 gap-2">
            <button className="rounded border border-gray-300 bg-white px-4 py-2 text-gray-600" onClick={closeModal}>
              Cancel
            </button>
            <button className="rounded bg-green px-4 py-2 text-white" onClick={confirmTechFormRequest}>
              Confirm
            </button>
          </div>
        </footer>
      </div>
    </Modal>
  );
}
